import { useState, useEffect,useRef } from "react";
import { useRouter } from "next/router";
import { SEODATA } from '@/config/seo_config';
import Head from "next/head";
// import TransportFormWrapper from "@/component/shared/shipment-calculator/transportFormWrapper";
import ShipmentCalc from "./shipment-calc";
import Image from 'next/image';
import IMAGES from "@/public/assets/img";
import { ShipCal } from "@/config/shipCal";
import { WEB_URL } from "@/config/endpoints";
import { pushCleverTapEvent } from "@/component/shared/pushCleverTapEvent";



export const metadata = {
    title: SEODATA.SHIPMENTCALCULATOR.title,
    description: SEODATA.SHIPMENTCALCULATOR.description,
    alternates: {
      canonical: SEODATA.SHIPMENTCALCULATOR.url
    },
    
    openGraph: {
      title: SEODATA.SHIPMENTCALCULATOR.title,
      description: SEODATA.SHIPMENTCALCULATOR.description,
      url: SEODATA.SHIPMENTCALCULATOR.url,
      imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    }
  };

const ShipmentLandingPageContent = () => {
  const router = useRouter();
  const { locale } = router;
  const [mWidth, setMWidth] = useState(0);
  const sectionRef = useRef(null);
   const topSectionRef = useRef(null);

  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }

  useEffect(() => {
      handleWindowResize();
      window.addEventListener('load', handleWindowResize);
      return () => window.removeEventListener('resize', handleWindowResize);
      
  }, [mWidth]);
  useEffect(()=>{
    pushCleverTapEvent("Shipping_Calculator_Visited", { "PageName": 'Shipping_Calculator' });
  },[]);
  const scrollToSection = () => {
    pushCleverTapEvent("Shipping_Calculator_Page_Calculate_Now_Button", { "PageName": 'Shipping_Calculator' });
    if (topSectionRef.current) {
      const headerOffset = 120;
      const elementPosition = topSectionRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <main>
        <Head>  
          <title>{metadata.title}</title>
          <meta name="description" content={metadata.description} />
          <meta property="og:title" content={metadata.openGraph.title}/>
          <meta property="og:description" content={metadata.openGraph.description} />
          <meta property="og:url" content={metadata.openGraph.url} />
          <link rel="canonical" href={metadata.alternates.canonical} />
          <meta property="og:image" content={metadata.openGraph.imagePath} />
          <script type="application/ld+json"
                dangerouslySetInnerHTML={{
                __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebApplication",
              "name": "Shipment Cost Calculator",
              "url": WEB_URL+'/shipment-calculator',
              "browserRequirements": "JavaScript-enabled browser",
              "applicationCategory": "BusinessApplication",
              "description": SEODATA.SHIPMENTCALCULATOR.description,
              "inLanguage": "en",
              "operatingSystem": "All",
              "publisher": {
                "@type": "Organization",
                "name": "Credlix"
              },
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "INR"
              }
            })
        }} />
        </Head>

        {/* <section className="sm:pt-[100px] pt-[122px]">
        <div ref={sectionRef}></div>
            <div className="shipBackground relative pt-20 pb-[200px] sm:pb-[80px] sm:pt-[80px] sm:bg-opacity-0">
                <div className='container lg:px-3  h-full xm:px-2 px-3'>
                    <h1 className="text-xl sm:text-base text-[#FECD2E] text-center font-medium mb-1">{ShipCal.shipBannerHeadOne}</h1>
                    <h2 className="text-heading2 text-white text-center font-bold whitespace-pre  sm:text-lg sm:whitespace-normal mb-1">{ShipCal.shipBannerHeadTwo}</h2>
                    <p className="text-lg text-white text-center sm:text-xs"> {ShipCal.shipBannerHeaderThree}</p>
                </div>
            </div>
        </section> */}

        <section id="formsection" className=""  ref={topSectionRef}>
            {/* <TransportFormWrapper />   */}
            <ShipmentCalc />
        </section> 

        {/* Shipment Cost Estimate */}
        <section className="pb-[100px] sm:pb-[50px]">
            <div className='container lg:px-3  h-full xm:px-2 pt-24 px-3'>
              <div className="flex justify-between sm:flex-wrap">
                <div className="w-1/2 sm:w-full">
                  <h2 className="text-xxxl text-[#2c2c2c] font-bold mb-3 sm:text-center">{ShipCal.secionOneHead}</h2>
                  <p className="text-base text-[#2c2c2c] sm:text-center">{ShipCal.secionOneDesc}</p>
                </div>
                <div className="w-[40%] sm:w-full">
                  <Image src={IMAGES.shipmentCalculator.shipmentOne} alt={IMAGES.shipmentCalculator.shipmentOne} width={360} height={250} className='ml-auto sm:mx-auto w-[300px] sm:w-[280px] sm:mt-5 ' />
                </div>
              </div>
            </div>
        </section>

        {/* Why Use Shipment Cost Calculator Heading */}
        <section className="pt-[50px] relative h-[450px] sm:h-[600px]">
            <div className='container lg:px-3 h-full xm:px-2 px-3 relative z-10'>
              <div className="text-center">
                <h2 className="text-xxxl text-[#2c2c2c] font-bold mb-3 ">{ShipCal.sectionTwoHead}</h2>
                <p className="text-base text-[#2c2c2c] max-w-[80%] sm:max-w-full mx-auto">{ShipCal.sectionTwoDesc}</p>
              </div>              
            </div>
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white to-[#E0EFFF] rounded-b-[300px] z-0">
            </div>
        </section>

        {/* Why Use Shipment Cost Calculator Inner Section */}
        <section className="mt-[-180px] sm:mt-[-140px] bg-transparent z-10 relative pb-[100px] sm:pb-[50px]">
          <div className='container lg:px-3 h-full xm:px-2 px-3'>
            <div className="flex space-x-5 sm:space-x-0 sm:flex-wrap">
              {ShipCal.benefitList.map((item, index)=>(
                <div key={item.name} className="w-[25%] sm:w-full sm:mb-2 bg-white p-3 sm:px-1 border border-[#E6E6E6] rounded-[15px] shadow-md flex flex-wrap sm:flex-nowrap sm:justify-between">
                  <div className={`rounded-[8px] p-2 sm:p-0 sm:w-[55px] sm:h-[50px] flex items-center justify-center mb-2 sm:mb-0 ${index === 0 ? "bg-[#FCE2E8]" : index === 1 ? "bg-[#DBFFF9]" : index === 2 ? "bg-[#D5E8FF]"  : index === 3 ? "bg-[#FFF6D3]"  :  ""}`}>
                    <Image src={item.img} alt={item.name} width={35} height={35} className="w-[35px] h-[35px] sm-w-[25px] sm:h-[25px] " />
                  </div>
                  <div className="sm:w-[calc(100%-55px)] sm:ml-[20px]">
                    <h3 className="text-lg text-[#2c2c2c] font-bold mb-[10px] sm:text-sm">{item.name}</h3>
                    <p className="text-base text-[#2c2c2c] sm:text-xs">{item.text}</p>
                  </div>
                </div> 
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}

         <section className="bg-transparent z-10 relative pb-[100px] sm:pb-[50px]">
          <div className='container lg:px-3  h-full xm:px-2 px-3'>
          <h2 className="text-xxxl text-[#2c2c2c] text-center text-heading5 leading-[48px] mb-[50px] font-normal">{ShipCal.sectionThreeHead}</h2>
            <div className="flex sm:flex-wrap">
              {ShipCal.howItWorksList.map((item, index)=>(
                <div key={item.name} className={`w-[30%] sm:w-full p-3 flex flex-wrap sm:flex-nowrap relative sm:justify-between ${index === 0 ? "bg-[#FFECE2] mr-[100px] sm:mr-0 sm:mb-[100px] after-arrow" : index === 1 ? "bg-[#E0FFE0] mr-[100px] sm:mr-0 sm:mb-[100px] after-arrow" : index === 2 ? "bg-[#FFF8E3]" :  ""}`}>
                  <div className="mb-5 sm:mb-0 sm:w-[48px] sm:h-[48px]">
                    <Image src={item.img} alt={item.name} width={48} height={48} className="w-[48px] h-[48px]" />
                  </div>

                  <div className="sm:w-[calc(100%-55px)] sm:ml-[20px]">
                    <h3 className="text-lg sm:text-base text-[#2c2c2c] font-bold mb-[10px]">{item.name}</h3>
                    <p className="text-base sm:text-sm text-[#2c2c2c]" dangerouslySetInnerHTML={{__html: item.text}}/>
                  </div>
                </div> 
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="pb-[100px] sm:pb-[50px]">
            <div className='container lg:px-3 h-full xm:px-2 px-3'>
              <div className="flex justify-between">

                { mWidth > 1023 &&
                  <div className="w-1/2 pr-5">
                    <Image src={IMAGES.shipmentCalculator.features} alt={IMAGES.shipmentCalculator.features} width={600} height={600} className='mr-auto max-w-[90%]' />
                  </div>
                }
                <div className="w-1/2 sm:w-full">
                  <h2 className="text-xxxl text-[#022B5C] font-bold mb-5 sm:text-center">{ShipCal.featuresHead}</h2>
                  { mWidth < 1023 &&
                    <Image src={IMAGES.shipmentCalculator.features} alt={IMAGES.shipmentCalculator.features} width={600} height={600} className='mr-auto max-w-[100%] mb-[80px]' />
                  }
                  {ShipCal.featuresList.map((item, index)=>(
                    <div key={item.name} className={`relative`}>
                      <div className="flex items-start mb-5">
                        <span className="mr-2">
                          <svg xmlns="https://www.w3.org/2000/svg" viewBox="2 2 20 20" fill="#7CB521" width={25} height={25} className="border border-[#022B5C] rounded-full p-0 m-0 box-border overflow-visible">
                           <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </span>
                        <div>
                          <h3 className="text-base2 text-[#022B5C] font-bold mb-[10px]">{item.name}</h3>
                          <p className="text-base2 text-[#022B5C]"> {item.text}</p>
                        </div>
                      </div>
                    </div> 
                  ))}
                </div>
              </div>
            </div>
        </section>

        {/* Ready to Calculate */}
        <section className="py-[70px] bg-[#FECD2F]">
            <div className='container lg:px-3  h-full xm:px-2 px-3'>
              <div className="flex justify-between items-center sm:flex-wrap">
                <div className="w-1/2 pr-5 sm:w-full sm:pr-0">
                  <h3 className="mb-3 text-base2 text-[#2C2C2C] font-bold">{ShipCal.calculateHead}</h3>
                  <p className="text-base text-[#2C2C2C] mb-5">{ShipCal.calculateSubHead}</p>
                  {mWidth > 1023 &&
                    <button className="py-1 px-[50px] rounded-[40px] text-white text-lg font-normal bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]" type="button" onClick={scrollToSection}>
                        Calculate Now
                    </button>
                  }
                </div>
                <div className="w-1/2 sm:w-full">
                  <div className="flex flex-wrap ml-auto w-[65%] sm:w-full justify-between">
                  {ShipCal.calculateList.map((item, index)=>(
                    <div key={item.name} className="w-[48%] mb-[4%] bg-white rounded-[15px] border border-[#E6E6E6] p-3">
                          <Image src={item.img} alt={item.name} width={35} height={35} className="w-[35px] h-[35px] mx-auto mb-3" />
                          <p className="text-base text-[#3C3C3C] text-center font-medium">{item.name}</p>
                      </div>
                    ))}
                  </div>

                  {mWidth < 1023 &&
                    <button className="py-1 block mx-auto mt-5 px-[50px] rounded-[40px] text-white text-lg font-normal bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]" type="button" onClick={scrollToSection}>
                        Calculate Now
                    </button>
                  } 
                </div>
              </div>
            </div>
        </section>

    </main>
  );
};

export default ShipmentLandingPageContent;